module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-navigation-container"
  }, [(this.$props.showModeNavigation) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sticky-footer-mobile"
  }, [(_vm.$store.state.common.isModeSwipe != true) ? _c('div', {
    staticClass: "fullscreen",
    on: {
      "click": _vm.navigateToFullScreen
    }
  }, [_c('span', [_vm._v("Full")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (this.$props.isModeSwipe) ? _c('div', {
    staticClass: "fullscreen",
    on: {
      "click": _vm.navigateToListView
    }
  }, [_c('span', [_vm._v("List")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "map-view",
    on: {
      "click": _vm.navigateToMapView
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Map")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sticky-footer-common hidden-md-and-up",
    attrs: {
      "id": "user-footer"
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "footer-icons text-dark text-decoration-none",
    on: {
      "click": _vm.navigateToSaved
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Travel List")])]), _vm._v(" "), _c('span', {
    staticClass: "footer-icons user_account text-dark text-decoration-none",
    on: {
      "click": _vm.navigateToProfile
    }
  }, [(!this.$props.isLoggedIn && this.$props.screenW < 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!this.$props.isLoggedIn && this.$props.screenW > 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": this.$props.user.photoURL
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Me")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("zoom_out_map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("reorder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("map")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-icons text-dark text-decoration-none",
    attrs: {
      "href": "https://www.withaview.co/"
    }
  }, [_c('button', [_c('img', {
    staticClass: "wav-icon-footer",
    attrs: {
      "loading": "lazy",
      "height": "16",
      "src": require("../../../static/img/vectorpaint.svg")
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d8d15c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/bottomNavigation.vue
// module id = 843
// module chunks = 4